import { useSetImmerAtom } from 'jotai-immer';
import { useCallback, useEffect, useState } from 'react';
import { ngContext } from '../../../../core/services/ng.delegate';

// provider imports
import providerRepo from '../../data/providerRepo';
import { providerPageStateAtom } from '../provider_list_atoms';
import { PreloadState } from '../../../../core/page/page.types';
import { useProviderListDestroy } from './useProviderListDestroy';

// page init sets up the initial page mode after pre-loading any data/permissions
export const useProviderListInit = (): boolean => {
    const [preloadState, setPreloadState] = useState<PreloadState>('init');
    const setPageState = useSetImmerAtom(providerPageStateAtom);

    // atom cleanup hook, on unmount it clears all page atoms
    useProviderListDestroy();

    const preloadPage = useCallback(async () => {
        // ASYNC: preload npi options

        const ceOptions = await providerRepo.preloadCeOptions();
        const ctx = ngContext();
        setPageState(draft => {
            draft.canEdit = ctx.User?.Type === 'VERITYSA';
            draft.ceOptions = ceOptions;
            draft.init = false;
            draft.loading = false;
            draft.action = 'QUERY'; // advance page to QUERY mode
            return draft;
        });

        setPreloadState('done');
    }, [setPageState]);

    useEffect(() => {
        // page: pre-load data and permissions before page load
        // this is here because we have a QUERY/TABLE pattern where both will be re-loaded frequently
        if (preloadState === 'init') {
            setPreloadState('loading');

            // ASYNC preload
            setPageState(draft => {
                draft.init = true;
                draft.action = '';
                draft.loading = true;
                return draft;
            });

            preloadPage();
        }
    }, [preloadState, setPreloadState, setPageState, preloadPage]);

    return preloadState === 'done';
};
